import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import Bubble from '@/Components/Bubble/Bubble';
import { observer } from 'mobx-react-lite';
import { useCallback } from 'react';
const SearchBubbles = ({ searchOptions }) => {
    const { includeProtectedContents, includeArchived, includeTrashed } = searchOptions;
    const toggleIncludeProtectedContents = useCallback(async () => {
        await searchOptions.toggleIncludeProtectedContents();
    }, [searchOptions]);
    return (_jsxs(_Fragment, { children: [_jsx(Bubble, { label: "Protected Contents", selected: includeProtectedContents, onSelect: toggleIncludeProtectedContents }), _jsx(Bubble, { label: "Archived", selected: includeArchived, onSelect: searchOptions.toggleIncludeArchived }), _jsx(Bubble, { label: "Trashed", selected: includeTrashed, onSelect: searchOptions.toggleIncludeTrashed })] }));
};
export default observer(SearchBubbles);
